import React, {useEffect, useState} from 'react'
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import SuccessModal from "../../../CustomModal/Success";
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileUpload from "../../../FileUploads/FileUpload";

toast.configure()

const TollCreate = ({
                        accountDetailsById,
                        accountDetailsByIdData = [],
                        match,
                        history,
                        getCityByStateId,
                        locationState,
                        geoCity = [],
                        state = [],
                        saveToll,
                        saveTollDetails = [],
                        tollById,
                        tollView = [],
                        documentUploadUrlPublic,
                        documentUrlDataPublic
                    }) => {
    const [inputList, setInputList] = useState([{
        client_name: '',
        client_lat: '',
        client_long: '',
        city_id: '',
        state_id: '',
        fast_tag_toll_no: '',
        document:'',
        latitude:'',
        longitude:''
    }]);

    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [userMessage, setUserMessage] = useState('')

    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [redirectUrl, setRedirectUrl] = useState('')
    const [userId, setUserId] = useState('')
    const [roleId, setRoleId] = useState('')
    const [isView, setIsView] = useState(false)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await locationState()
            if (match?.params?.account_id !== undefined) {
                await tollById(match?.params?.account_id)
            }
            setUserId(window.localStorage.user_id)
            setRoleId(window.localStorage.role_id)
            setIsLoading(false)
        })()
    }, [])

    const handleInput = (val, index) => {
        const list = [...inputList]
        list[0][index] = val
        setInputList(list)
    }

    useEffect(() => {
        if (tollView?.data !== undefined && Object.keys(tollView?.data).length > 0) {
            (async () => {
                setIsEdit(true)
                let list = [...inputList]
                list[0]['client_name'] = tollView?.data?.client_name
                list[0]['fast_tag_toll_no'] = tollView?.data?.fast_tag_toll_no
                list[0]['id'] = tollView?.data?.id
                list[0]['type'] = tollView?.data?.account_type
                list[0]['city_id'] = tollView?.data?.city_id
                list[0]['state_id'] = tollView?.data?.state_id
                list[0]['document'] = tollView?.data?.document
                list[0]['latitude'] = tollView?.data?.latitude
                list[0]['longitude'] = tollView?.data?.longitude

                setInputList(list)
                setIsLoading(true)
                await getCityByStateId(tollView?.data?.state_id)
                setIsLoading(false)
            })()
        }
    }, [tollView])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (parseInt(saveTollDetails?.status) === 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsSuccessModalOpen(true)
            setUserMessage(saveTollDetails?.message)
            setRedirectUrl('fast-tag-toll-list')
        } else if (saveTollDetails?.status !== undefined && saveTollDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setUserMessage(saveTollDetails?.message)
        }
    }, [saveTollDetails])

    // useEffect(() => {
    //     setIsFailedModalOpen(false)
    //     setIsSuccessModalOpen(false)
    //     if (parseInt(updateAccountDetails?.status) === 200) {
    //         setCountToOpenModal(countToOpenModal + 1)
    //         setIsSuccessModalOpen(true)
    //         setUserMessage(updateAccountDetails?.message)
    //         if (match?.params?.lead_id !== undefined) {
    //             setRedirectUrl('list-account/' + match?.params?.lead_id)
    //         } else {
    //             setRedirectUrl('list-account')
    //         }
    //     } else if (updateAccountDetails?.status !== undefined && updateAccountDetails?.status !== 200) {
    //         setCountToOpenModal(countToOpenModal + 1)
    //         setIsFailedModalOpen(true)
    //         setUserMessage(updateAccountDetails?.message)
    //     }
    // }, [updateAccountDetails])

    useEffect(() => {
        if (match?.params?.id !== undefined) {
            (async () => {
                setIsLoading(true)
                await accountDetailsById(match?.params?.id)
                setIsLoading(false)
            })()
        }
    }, [match.params.id])


    const handleGetCityByState = async (id) => {
        setIsLoading(true)
        await getCityByStateId(id)
        setIsLoading(false)
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0]
        requestParams['client_lat'] = islatlng?.lat
        requestParams['client_long'] = islatlng?.lng
        requestParams['is_draft'] = false
        // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
        if (requestParams['client_lat'] == null || requestParams['client_long'] == null) {
            toast.error('Please enable your location');
            return false
        }

        // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
        // return
        setIsLoading(true)

        if (isEdit) {
            requestParams['id'] = match?.params.account_id
            await saveToll(requestParams)
        } else {
            await saveToll(requestParams)
        }
        setIsLoading(false)
    }


    const handleDraft = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0]


        if (requestParams['client_name'] === '') {
            toast.error('Toll name is required')
            return false
        }

        if (requestParams['type'] === '') {
            toast.error('Toll type is required')
            return false
        }


        requestParams['is_draft'] = true
        // requestParams['latitude'] = islatlng?.lat
        // requestParams['longitude'] = islatlng?.lng
        requestParams['client_lat'] = mapLocation?.lat
        requestParams['client_long'] = mapLocation?.lng

        if (requestParams['client_lat'] == null || requestParams['client_long'] == null) {
            toast.error('Please enable your location');
            return false
        }

        // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
        // return
        setIsLoading(true)
        if (isEdit) {
            requestParams['id'] = match?.params.account_id
             await saveToll(requestParams)
        } else {
            await saveToll(requestParams)
        }
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={userMessage}
                url={redirectUrl}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={userMessage}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Fast Tag Toll'}
                            history={history}
                        />
                        {/*BODY*/}
                        <div>
                            <div className="container-fluid">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                                            </div>
                                            <div className="mb-4 bg-white"> {/*card*/}
                                                <div className="hide card-header bg-lightGreen-active">
                                                    POC Details
                                                </div>
                                                <div className="card-body">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'client_name', e)
                                                                       }}
                                                                       required
                                                                       value={inputList[0]?.client_name}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Toll Name <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput(e.target.value, 'type', e)
                                                                    }} required>
                                                                    <option value="">Select Type</option>
                                                                    {tollView?.data?.account_type !== undefined && tollView?.data?.account_type === "National" &&
                                                                        <>
                                                                            <option
                                                                                value="National" selected>National
                                                                            </option>
                                                                            <option
                                                                                value="MoRTH">MoRTH
                                                                            </option>
                                                                            <option
                                                                                value="State">State
                                                                            </option>
                                                                        </>
                                                                    }
                                                                    {tollView?.data?.account_type !== undefined && tollView?.data?.account_type === "MoRTH" &&
                                                                        <>
                                                                            <option
                                                                                value="National">National
                                                                            </option>
                                                                            <option
                                                                                value="MoRTH" selected>MoRTH
                                                                            </option>
                                                                            <option
                                                                                value="State">State
                                                                            </option>
                                                                        </>
                                                                    }
                                                                    {tollView?.data?.account_type !== undefined && tollView?.data?.account_type === "State" &&
                                                                        <>
                                                                            <option
                                                                                value="National">National
                                                                            </option>
                                                                            <option
                                                                                value="MoRTH">MoRTH
                                                                            </option>
                                                                            <option
                                                                                value="State" selected>State
                                                                            </option>
                                                                        </>
                                                                    }
                                                                    {tollView?.data?.account_type === undefined &&
                                                                        <>
                                                                            <option
                                                                                value="National">National
                                                                            </option>
                                                                            <option
                                                                                value="MoRTH">MoRTH
                                                                            </option>
                                                                            <option
                                                                                value="State">State
                                                                            </option>
                                                                        </>
                                                                    }

                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Type
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'fast_tag_toll_no', e)
                                                                       }}
                                                                       required
                                                                       value={inputList[0]?.fast_tag_toll_no}
                                                                       disabled={isEdit}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                        Plaza ID <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput(e.target.value, 'state_id', e)
                                                                        handleGetCityByState(e.target.value)
                                                                    }}>
                                                                    <option value="">Select State</option>
                                                                    {state !== [] && state.map((val) => {
                                                                        return (
                                                                            <>
                                                                                {tollView?.data?.state_id !== undefined && parseInt(tollView?.data?.state_id) === val?.id ?
                                                                                    <option
                                                                                        value={val?.id}
                                                                                        selected>{val.name}
                                                                                    </option>
                                                                                    :
                                                                                    <option
                                                                                        value={val?.id}>{val.name}
                                                                                    </option>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    State
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput(e.target.value, 'city_id', e)
                                                                    }}>
                                                                    <option value="">Select City</option>
                                                                    {geoCity?.data !== undefined && geoCity?.data.map((val) => {
                                                                        return (
                                                                            <>
                                                                                {tollView?.data?.city_id !== undefined && parseInt(tollView?.data?.city_id) === val?.id ?
                                                                                    <option
                                                                                        value={val?.id}
                                                                                        selected>{val.name}
                                                                                    </option>
                                                                                    :
                                                                                    <option
                                                                                        value={val?.id}>{val.name}
                                                                                    </option>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    City
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="number"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'latitude', e)
                                                                       }}
                                                                       required
                                                                       value={inputList[0]?.latitude}
                                                                       disabled={parseInt(roleId) !== 67}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Latitude <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div
                                                                className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="number"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'longitude', e)
                                                                       }}
                                                                       required
                                                                       value={inputList[0]?.longitude}
                                                                       disabled={parseInt(roleId) !== 67}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Longitude <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>

                                                            <div className="col-sm-6 mtk-1 float-field mb-3">
                                                                <FileUpload
                                                                    id={"addAttachment"}
                                                                    accept=".png,.jpg,.jpeg"
                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                    documentUrlData={documentUrlDataPublic}
                                                                    onChange={(e, val) => {
                                                                        handleInput(e, 'document')
                                                                    }}
                                                                    prefilledFilename={""}
                                                                >
                                                                    File Attachment
                                                                </FileUpload>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        {/*{!isView ?*/}
                                        <>
                                            <div className="col-sm-12 mb-4">
                                                <button className="btn btn-primary btn-user btn-block submit-btn">
                                                    {isEdit ? "Update" : 'Submit'}
                                                </button>
                                            </div>
                                            {!isEdit || (tollView.data?.is_draft !== undefined && parseInt(tollView.data?.is_draft) === 1) ?
                                                <>
                                                    <div className="col-sm-6">
                                                        <a href="#" className="draft-float"
                                                           onClick={(e) => handleDraft(e)}>
                                                            <p className="my-float">Draft</p>
                                                        </a>
                                                    </div>
                                                </>
                                                : ''
                                            }
                                        </>
                                        :
                                        <>
                                            {userId !== '' && parseInt(userId) === parseInt(tollView.data?.assigned_to) && tollView.data?.account_type_id !== undefined
                                                &&
                                                // (parseInt(roleId) === 5 || parseInt(roleId) === 6 || parseInt(roleId) === 7 || parseInt(roleId) === 16 || parseInt(roleId) === 4) &&
                                                <div className="col-sm-6">
                                                    <a href={match?.params?.lead_id !== undefined ? `/edit-account/${match?.params?.id}/${match?.params?.lead_id}` : `edit-account/${match?.params?.id}`}
                                                       className="draft-float">
                                                        <p className="my-float">Edit</p>
                                                    </a>
                                                </div>
                                            }
                                        </>
                                        {/*}*/}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default TollCreate